import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import HomePage from "@/pages/HomePage";
import SearchPage from "@/pages/SearchPage";
import ListingDetailPage from "@/pages/ListingDetailPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import OwnerDashboard from "@/pages/OwnerDashboard";
import TravelerDashboard from "@/pages/TravelerDashboard";
import MessagesPage from "@/pages/MessagesPage";
import BookingSuccessPage from "@/pages/BookingSuccessPage";
import BecomeHostPage from "@/pages/BecomeHostPage";
import BecomePartnerPage from "@/pages/BecomePartnerPage";
import PartnersDirectoryPage from "@/pages/PartnersDirectoryPage";
import PartnerDetailPage from "@/pages/PartnerDetailPage";
import AdminPartnersPage from "@/pages/AdminPartnersPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import ResourcesPage from "@/pages/ResourcesPage";
import ResourceArticlePage from "@/pages/ResourceArticlePage";
import ConciergeDashboardPage from "@/pages/ConciergeDashboardPage";
import SupportPage from "@/pages/SupportPage";
import LogoPreviewPage from "@/pages/LogoPreviewPage";
import WishlistsPage from "@/pages/WishlistsPage";
import CityPage from "@/pages/CityPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/listings/:id" element={<ListingDetailPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/become-host" element={<BecomeHostPage />} />
            <Route path="/ressources" element={<ResourcesPage />} />
            <Route path="/ressources/:slug" element={<ResourceArticlePage />} />
            <Route path="/partenaires" element={<PartnersDirectoryPage />} />
            <Route path="/partenaires/:id" element={<PartnerDetailPage />} />
            <Route path="/devenir-partenaire" element={<BecomePartnerPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/conciergerie" element={<ProtectedRoute><ConciergeDashboardPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboardPage /></ProtectedRoute>} />
            <Route path="/admin/partners" element={<ProtectedRoute><AdminPartnersPage /></ProtectedRoute>} />
            <Route path="/logo" element={<LogoPreviewPage />} />
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/wishlists" element={<ProtectedRoute><WishlistsPage /></ProtectedRoute>} />
            <Route path="/ville/:slug" element={<CityPage />} />
            <Route
              path="/owner"
              element={
                <ProtectedRoute role="owner">
                  <OwnerDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/traveler"
              element={
                <ProtectedRoute>
                  <TravelerDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/messages"
              element={
                <ProtectedRoute>
                  <MessagesPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
